import "../askgvt.css";
import { render } from "solid-js/web";
import { CategoryApp } from "./CategoryApp";

const mount = () => {
	render(() => <CategoryApp />, document.body);
};

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", mount);
} else {
	mount();
}
